import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PatientGroup } from 'src/app/data/dietitian/domain/patient_group/patient_group';
import { Patient } from 'src/app/data/patient/domain/patient';

import { PatientGroupPatientListFacade } from './patient-group-patient-list.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-patient-group-patient-list',
  templateUrl: './patient-group-patient-list.component.html',
  styleUrls: ['./patient-group-patient-list.component.scss'],
  providers: [PatientGroupPatientListFacade],
})
export class PatientGroupPatientListComponent {
  private _patientGroup: PatientGroup | undefined;
  @Input() set patientGroup(value: PatientGroup | undefined) {
    this._patientGroup = value;
    this.loadPatientGroupPatients().then();
  }
  get patientGroup(): PatientGroup | undefined {
    return this._patientGroup;
  }

  @Output() onBack = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  patients: Patient[] = [];
  isLoading = true;
  error?: string;

  constructor(private facade: PatientGroupPatientListFacade) {
    // do nothing
  }

  async loadPatientGroupPatients() {
    this.isLoading = true;
    this.error = undefined;
    try {
      if (this.patientGroup) {
        this.patients = await this.facade.getPatientGroupPatients(
          this.patientGroup.dietitianId.id.toString(),
          this.patientGroup.id.toString(),
        );
      } else {
        this.patients = [];
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        this.error = error.message;
      }
    }
    this.isLoading = false;
  }
}
